import { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import "./styles/index.scss";
import {
  getAuthToken,
  setAuthToken,
  setCompanyCode,
  setExpiresOn,
} from "./utils/storage";
import { useDispatch } from "react-redux";
import { setApiDispatch } from "./services/api";

/** LAYOUTS */
const DefaultUserLayout = lazy(() =>
  import("./components/layout/default-layout.component")
);
/** PAGES */
const Product = lazy(() => import("./pages/Product"));
const Wise = lazy(() => import("./pages/DynamicHome"));
const Login = lazy(() => import("./pages/Login"));

function App() {
  const navigate = useNavigate();
  const url = new URL(window.location.href);
  const companyCode = url.searchParams.get("companycode");
  const token = url.searchParams.get("token");
  useEffect(() => {
    if (companyCode && token) {
      setCompanyCode(companyCode);
      setAuthToken(token);
      setExpiresOn(Date.now() + 3600 * 1000); // Set expiresOn to 1 hour from now
      getUser();
    }
  }, [companyCode, token]);

  const getUser = () => {
    navigate("/product/wise", { replace: true });
  };

  const dispatch = useDispatch();

  useEffect(() => {
    setApiDispatch(dispatch); // Set dispatch for API error handling
  }, [dispatch]);
  const isAuthenticatedToken =
    !!getAuthToken() && getAuthToken() !== "undefined";
  return (
    <Suspense>
      <Routes>
        {!isAuthenticatedToken ? (
          <>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <Route path="/" element={<DefaultUserLayout />}>
            <Route index path="/product" element={<Product />} />
            <Route path="/product/wise" element={<Wise />} />
            <Route
              path="/product/*"
              element={<Navigate to="/product/wise" replace />}
            />
            <Route path="*" element={<Navigate to="/product" replace />} />
            <Route path="/" element={<Navigate to="/product" replace />} />
          </Route>
        )}
      </Routes>
    </Suspense>
  );
}

export default App;
